"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsCalendar = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AdapterDayjs = require("@mui/x-date-pickers/AdapterDayjs");
var _LocalizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _DatePicker = require("@mui/x-date-pickers/DatePicker");
var _DateField = require("@mui/x-date-pickers/DateField");
var _material = require("@mui/material");
var _DateTimePicker = require("@mui/x-date-pickers/DateTimePicker");
var _DateTimeField = require("@mui/x-date-pickers/DateTimeField");
var _TimePicker = require("@mui/x-date-pickers/TimePicker");
var _TimeField = require("@mui/x-date-pickers/TimeField");
const _excluded = ["fieldType", "label", "value", "onChange"],
  _excluded2 = ["pickerType", "label", "value", "onChange", "max", "min"],
  _excluded3 = ["pickerType", "startLabel", "endLabel", "start", "end", "onChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Renders a flexible field based on the type: date, time, or datetime.
 */
const DmsFlexibleField = _ref => {
  let {
      fieldType,
      label,
      value,
      onChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterDayjs.AdapterDayjs
  }, fieldType === "date" && /*#__PURE__*/_react.default.createElement(_DateField.DateField, _extends({
    label: label,
    value: value,
    onChange: onChange
  }, props)), fieldType === "datetime" && /*#__PURE__*/_react.default.createElement(_DateTimeField.DateTimeField, _extends({
    label: label,
    value: value,
    onChange: onChange
  }, props)), fieldType === "time" && /*#__PURE__*/_react.default.createElement(_TimeField.TimeField, _extends({
    label: label,
    value: value,
    onChange: onChange
  }, props)));
};
DmsFlexibleField.propTypes = {
  fieldType: _propTypes.default.oneOf(['date', 'datetime', 'time']).isRequired,
  label: _propTypes.default.string,
  value: _propTypes.default.any,
  onChange: _propTypes.default.func
};

/**
 * Renders a flexible picker (DatePicker, TimePicker, or DateTimePicker).
 */
const DmsFlexiblePicker = _ref2 => {
  let {
      pickerType,
      label,
      value,
      onChange,
      max,
      min
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterDayjs.AdapterDayjs
  }, pickerType === "date" && /*#__PURE__*/_react.default.createElement(_DatePicker.DatePicker, _extends({
    label: label,
    value: value,
    onChange: onChange,
    maxDate: max,
    minDate: min
  }, props)), pickerType === "datetime" && /*#__PURE__*/_react.default.createElement(_DateTimePicker.DateTimePicker, _extends({
    label: label,
    value: value,
    onChange: onChange,
    maxDateTime: max,
    minDateTime: min
  }, props)), pickerType === "time" && /*#__PURE__*/_react.default.createElement(_TimePicker.TimePicker, _extends({
    label: label,
    value: value,
    onChange: onChange,
    maxTime: max,
    minTime: min
  }, props)));
};
DmsFlexiblePicker.propTypes = {
  pickerType: _propTypes.default.oneOf(['date', 'datetime', 'time']).isRequired,
  label: _propTypes.default.string,
  value: _propTypes.default.any,
  onChange: _propTypes.default.func,
  max: _propTypes.default.any,
  min: _propTypes.default.any
};

/**
 * Renders a date/time range picker with two inputs for start and end values.
 * 
 * @component
 * @param {Object} props
 * @param {"date"|"datetime"|"time"} props.pickerType - Type of picker to render
 * @param {string} [props.startLabel="Start"] - Label for start picker
 * @param {string} [props.endLabel="End"] - Label for end picker
 * @param {*} [props.start=null] - Start value
 * @param {*} [props.end=null] - End value
 * @param {Function} props.onChange - Callback when either date changes
 * @returns {JSX.Element}
 */
const PickerRange = _ref3 => {
  let {
      pickerType,
      startLabel = "Start",
      endLabel = "End",
      start = null,
      end = null,
      onChange
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded3);
  const handleStartChange = newValue => {
    if (end && newValue && newValue.isAfter(end)) {
      onChange === null || onChange === void 0 || onChange({
        startDate: newValue,
        endDate: null
      });
    } else {
      onChange === null || onChange === void 0 || onChange({
        startDate: newValue,
        endDate: end
      });
    }
  };
  const handleEndChange = newValue => {
    onChange === null || onChange === void 0 || onChange({
      startDate: start,
      endDate: newValue
    });
  };
  return /*#__PURE__*/_react.default.createElement(_LocalizationProvider.LocalizationProvider, {
    dateAdapter: _AdapterDayjs.AdapterDayjs
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(DmsCalendar.DmsFlexiblePicker, _extends({
    pickerType: pickerType,
    label: startLabel,
    value: start,
    onChange: handleStartChange,
    max: end || undefined
  }, props))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react.default.createElement(DmsCalendar.DmsFlexiblePicker, _extends({
    pickerType: pickerType,
    label: endLabel,
    value: end,
    onChange: handleEndChange,
    min: start || undefined
  }, props)))));
};
PickerRange.propTypes = {
  pickerType: _propTypes.default.oneOf(['date', 'datetime', 'time']).isRequired,
  startLabel: _propTypes.default.string,
  endLabel: _propTypes.default.string,
  start: _propTypes.default.any,
  end: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired
};
const DmsCalendar = exports.DmsCalendar = {
  DmsFlexiblePicker,
  DmsFlexibleField,
  PickerRange
};